<div class="text-body bg-color-light-white padding-top-48 padding-bottom-48">
  <div class="container">
    <div class="row">
      <div class="col-md-6 margin-bottom-20">
        <div class="row">
          <div class="margin-bottom-20 col-sm-6">
            <p>
              <b>{{ 'footer.contact.indonesia.country' | translate }}</b>
            </p>

            <p class="margin-top-12">
              <b>{{ 'footer.caption.investor' | translate }}</b>
              <br />
              <a
                href="mailto:{{ 'footer.contact.indonesia.investor-contact-email' | translate }}"
              >
                {{ 'footer.contact.indonesia.investor-contact-email' | translate
                }}
              </a>
              <br />
              {{ 'footer.contact.indonesia.investor-contact-number' | translate
              }}
            </p>

            <p class="margin-top-12">
              <b>{{ 'footer.caption.borrower' | translate }}</b>
              <br />
              <a
                href="mailto:{{ 'footer.contact.indonesia.borrower-contact-email' | translate }}"
              >
                {{ 'footer.contact.indonesia.borrower-contact-email' | translate
                }}
              </a>
              <br />
              {{ 'footer.contact.indonesia.borrower-contact-number' | translate
              }}
            </p>

            <p
              [innerHtml]="( 'footer.contact.indonesia.address' | translate )"
            ></p>
          </div>

          <div class="col-sm-6">
            <p>
              <b>{{ 'footer.contact.singapore.country' | translate }}</b>
            </p>

            <p class="margin-top-12">
              <a
                href="mailto:{{ 'footer.contact.singapore.email' | translate }}"
              >
                {{ 'footer.contact.singapore.email' | translate }}
              </a>
              <br />{{ 'footer.contact.singapore.phone-number' | translate }}
            </p>

            <p
              class="margin-top-12"
              [innerHtml]="( 'footer.contact.singapore.address' | translate )"
            ></p>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row">
          <div class="margin-bottom-20 col-sm-6">
            <p>
              <b>{{ 'footer.contact.malaysia.country' | translate }}</b>
            </p>

            <p class="margin-top-12">
              <a href="mailto:{{ 'footer.contact.malaysia.email' | translate }}"
                >{{ 'footer.contact.malaysia.email' | translate }}</a
              >
              <br />{{ 'footer.contact.malaysia.phone-number' | translate }}
            </p>

            <p
              class="margin-top-12"
              [innerHtml]="( 'footer.contact.malaysia.address' | translate )"
            ></p>
          </div>

          <div class="col-sm-6">
            <p>
              <strong>{{ 'footer.contact.thailand.country' | translate }}</strong>
            </p>

            <p class="margin-top-12">
              <strong>{{ 'footer.caption.sme-loan' | translate }}</strong>
              <br />
              <a href="mailto:{{ 'footer.contact.thailand.sme-contact-email' | translate }}">
                {{ 'footer.contact.thailand.sme-contact-email' | translate }}
              </a>
              <br />{{ 'footer.contact.thailand.phone-number' | translate }}
            </p>

            <p class="margin-top-12">
              <strong>{{ 'footer.caption.investment' | translate }}</strong>
              <br />
              <a href="mailto:{{ 'footer.contact.thailand.investment-contact-email' | translate }}">
                {{ 'footer.contact.thailand.investment-contact-email' | translate }}
              </a>
              <br />
              {{ 'footer.contact.thailand.investment-contact-number' | translate }}
            </p>

            <p class="margin-top-12"
              [innerHtml]="( 'footer.contact.thailand.address' | translate )"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container footer padding-top-48 padding-bottom-48">
  <div class="row padding-bottom-16">
    <div class="col-md-9">
      <div class="row">
        <div class="col-sm-1 margin-top-15">
          <img class="img-responsive" src="/assets/img/_public/logo.svg" />
        </div>

        <div class="col-sm-11 line-height-175em">
          <div class="row footerNav">
            <ul class="margin-top-15 item col-sm-3" *ngIf="countryCode !== 'TH'">
              <li class="itemHeader">{{ 'footer.caption.service' | translate }}</li>
              <li>
                <a *ngIf="hasLandingPageFor('smeFinancing', countryCode)" [href]="landingPagePathFor('smeFinancing', countryCode)">
                  {{ 'footer.navigation.business-loan' | translate }}
                </a>
                <a *ngIf="hasLandingPageFor('smeLoans', countryCode)" [href]="landingPagePathFor('smeLoans', countryCode)">
                  {{ 'footer.navigation.business-loan' | translate }}
                </a>
                <a *ngIf="hasLandingPageFor('borrow', countryCode)" [href]="landingPagePathFor('borrow', countryCode)">
                  {{ 'footer.navigation.business-loan' | translate }}
                </a>
              </li>
              <li>
                <a *ngIf="hasLandingPageFor('invest', countryCode)" [href]="landingPagePathFor('invest', countryCode)">
                  {{ 'footer.navigation.investing' | translate }}
                </a>
                <a *ngIf="hasLandingPageFor('p2pInvestment', countryCode)" [href]="landingPagePathFor('p2pInvestment', countryCode)">
                  {{ 'footer.navigation.investing' | translate }}
                </a>
              </li>
              <li *ngIf="referralProgram">
                <a
                  href="/refer">{{ 'footer.navigation.referral' | translate }}</a>
              </li>
              <li *ngIf="CONFIGURATION.ecommercePageUrlBorrowPage">
                <a [href]="CONFIGURATION.ecommercePageUrlBorrowPage">
                  {{ 'footer.navigation.e-commerce-loan' | translate }}
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('partnersPortal', countryCode)">
                <a [href]="landingPagePathFor('partnersPortal', countryCode)">
                  {{ 'footer.navigation.partners' | translate }}
                </a>
              </li>
            </ul>

            <ng-container *ngIf="countryCode === 'TH'">
              <ul class="margin-top-15 item col-sm-3">
                <li class="itemHeader">{{ 'footer.caption.get-funding' | translate }}</li>
                <li>
                  <a href="/business-term-financing">
                    {{ 'footer.navigation.business-term-financing' | translate }}
                  </a>
                </li>
                <li>
                  <a href="/invoice-financing">
                    {{ 'footer.navigation.invoice-financing' | translate }}
                  </a>
                </li>
                <li>
                  <a href="/payable-financing">
                    {{ 'footer.navigation.payable-financing' | translate }}
                  </a>
                </li>
                <li>
                  <a href="/project-financing">
                    {{ 'footer.navigation.project-financing' | translate }}
                  </a>
                </li>
              </ul>
              <ul class="margin-top-15 item col-sm-3">
                <li class="itemHeader">{{ 'footer.caption.invest' | translate }}</li>
                <li>
                  <a href="/investor">
                  {{ 'footer.navigation.invest-with-us' | translate }}
                  </a>
                </li>
              </ul>
            </ng-container>
            <ul class="margin-top-15 item col-sm-3" *ngIf="footerMenuConfiguration.whoWeAre.show">
              <li class="itemHeader">{{ 'footer.caption.who-we-are' | translate }}</li>
              <li *ngIf="hasLandingPageFor('aboutUs', countryCode)">
                <a [href]="landingPagePathFor('aboutUs', countryCode)">
                  {{ 'footer.navigation.about-us' | translate }}
                </a>
              </li>
              <li *ngIf="footerMenuConfiguration.whoWeAre.subMenu.statistics">
                <a routerLink="/statistics">{{ 'footer.navigation.statistics' | translate }}</a>
              </li>
              <li *ngIf="footerMenuConfiguration.whoWeAre.subMenu.careers">
                <a href="/career">{{ 'footer.navigation.career' | translate }}</a>
              </li>
              <li  *ngIf="footerMenuConfiguration.whoWeAre.subMenu.ourStory" >
                <a role="button" href="{{CONFIGURATION.story}}" target="_blank">
                  {{ 'footer.navigation.our-story' | translate }}
                </a>
              </li>
              <li>
                <a role="button" href="{{CONFIGURATION.blog}}" target="_blank">
                  {{ 'footer.navigation.our-blog' | translate }}
                </a>
              </li>
              <li *ngIf="footerMenuConfiguration.whoWeAre.subMenu.help">
                <a href="{{ faqLink }}?utm_source=mainsite{{ countryCode }}&utm_medium=footer" target="_blank">
                  {{ 'footer.navigation.help' | translate }}
                </a>
              </li>
            </ul>

            <ul class="margin-top-15 item col-sm-3" *ngIf="footerMenuConfiguration.media.show">
              <li class="itemHeader">
                {{ 'footer.caption.media' | translate }}
              </li>
              <li *ngIf="CONFIGURATION.inTheNews">
                <a role="button" href="{{CONFIGURATION.inTheNews}}" target="_blank">
                  {{ 'footer.navigation.in-the-news' | translate }}
                </a>
              </li>
              <li>
                <a role="button" href="{{CONFIGURATION.mediapress}}" target="_blank">
                  {{ 'footer.navigation.event' | translate }}
                </a>
              </li>
              <li>
                <a role="button" href="{{CONFIGURATION.blog}}" target="_blank">
                  {{ 'footer.navigation.our-blog' | translate }}
                </a>
              </li>
              <li>
                <a *ngIf="countryCode !== 'SG'" role="button" (click)="goToLearningCenter()">
                  {{ 'footer.navigation.learning' | translate }}
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('pressAssets', countryCode)">
                <a [href]="landingPagePathFor('pressAssets', countryCode)">
                  {{ 'footer.navigation.press-assets' | translate }}
                </a>
              </li>
            </ul>

            <ul class="margin-top-15 item col-sm-3">
              <li class="itemHeader">
                {{ 'footer.caption.legal' | translate }}
              </li>
              <li *ngIf="hasLandingPageFor('websiteTerms', countryCode)">
                <a [href]="landingPagePathFor('websiteTerms', countryCode)">
                  {{ 'footer.navigation.website-terms' | translate }}
                </a>
              </li>
              <li>
                <a *ngIf="hasLandingPageFor('termsOfUse', countryCode)" [href]="landingPagePathFor('termsOfUse', countryCode)">
                  {{ 'footer.navigation.website-terms' | translate }}
                </a>
                <a *ngIf="['ID', 'MY'].includes(countryCode)" href="/terms-of-service">
                  {{ 'footer.navigation.term-of-service' | translate }}
                </a>
              </li>
              <li>
                <a href="/privacy-notice">
                  {{ 'footer.navigation.privacy-notice' | translate }}
                </a>
              </li>
              <li *ngIf="showPrivacyNoticeMalay">
                <a href="/privacy-notice/malay-version" target="_blank">
                  {{ 'footer.navigation.privacy-notice-malay' | translate }}
                </a>
              </li>
              <li *ngIf="hasLandingPageFor('termConditions', countryCode)">
                <a [href]="landingPagePathFor('termConditions', countryCode)">
                  {{ 'footer.navigation.term-condition' | translate }}
                </a>
              </li>
              <li *ngIf="showPrivacyNoticeInvoiceFinancing">
                <a href="/privacy-notice-invoice-financing">
                  {{ 'footer.navigation.privacy-notice-invoice-financing' | translate }}
                </a>
              </li>
              <li *ngIf="countryCode === 'ID'">
                <a href="/complaint-handling">
                  {{ 'footer.navigation.complaint-handling' | translate }}
                </a>
              </li>
              <li *ngIf="showDisclosureNotice">
                <a href="/risk-disclosure">
                  {{ 'footer.navigation.risk-disclosure' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <div class="footerBottom__sites margin-top-15">
        <div class="social-media-icons">
          <a *ngIf="mediaSocialLink.facebook" [href]="mediaSocialLink.facebook" target="_blank"
            class="social-media-icon facebook"></a>
          <a *ngIf="mediaSocialLink.twitter" [href]="mediaSocialLink.twitter" target="_blank"
            class="social-media-icon twitter"></a>
          <a *ngIf="mediaSocialLink.linkedin" [href]="mediaSocialLink.linkedin" target="_blank"
            class="social-media-icon linkedin"></a>
          <a *ngIf="mediaSocialLink.instagram" [href]="mediaSocialLink.instagram" target="_blank"
            class="social-media-icon instagram"></a>
          <a *ngIf="mediaSocialLink.line" [href]="mediaSocialLink.line" target="_blank"
            class="social-media-icon line-icon"></a>
          </div>
        <div class="select-site">
          <div class="change-language-box " role="button" (click)="openModal('languageDialog')">
            <span class="global-icon margin-right-10"></span> {{ getDefaultLanguageLabel() }}
          </div>

          <div class="ssl-secure-box">
            <div class="lock-icon"></div>
            <span class="margin-left-5">{{ 'footer.caption.ssl-secure-site' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="bg-color-gray-100 padding-top-16 padding-bottom-16">
  <div class="container">
    <div class="row padding-bottom-16">
      <div class="col-sm-6 font-size-16" *ngIf="showInvestorAppDownloadLinks">
        <p>{{ 'invest.header.app-investor-title' | translate }}</p>

        <a [href]="appLink.investorGooglePlay" target="_blank" class="app-container__app" id="android-app">
          <div class="app-download-link black-background">
            <span class="google-play-color-logo margin-top-5 margin-right-5"></span>
            <div>
              <span class="download-caption">{{ 'invest.header.download-on' | translate }}</span>
              <br>
              <span class="app-store">
                {{ 'invest.header.google-play' | translate }}
              </span>
            </div>
          </div>
        </a>

        <a [href]="appLink.investorAppStore" target="_blank" class="app-container__app" id="ios-app">
          <div class="app-download-link black-background">
            <span class="app-store-white-logo margin-top-5 margin-right-5"></span>
            <div>
              <span class="download-caption">{{ 'invest.header.download-on' | translate }}</span>
              <br>
              <span class="app-store">
                {{ 'invest.header.app-store' | translate }}
              </span>
            </div>
          </div>
        </a>
      </div>
      <div class="col-sm-6" *ngIf="!showInvestorAppDownloadLinks">
        <br /><p class="font-size-12">{{ 'footer.caption.licensed-by' | translate }} <span class="text-bold">{{ 'footer.caption.securities-commission' | translate }}</span></p>
      </div>

    </div>

    <div class="row">
      <div class="col-xs-12 line-height-15em">
        <small [innerHTML]="( 'footer.license' | translate )"></small>
      </div>

    </div>
  </div>
</div>

<modal id="languageDialog" class="fs-modal fs-modal__open fs-modal--hidden">
  <div class="fs-modal__background" (click)="closeModal('languageDialog')"></div>
  <div class="fs-modal__dialog fs-modal__dialog--centered language-dialog">
    <div class="fs-modal__content">
      <div class="fs-modal__header fs-modal__header--noborder">
        <h5 class="fs-modal__title fs-modal__title--centered">{{ 'footer.language-pop-up.title' | translate }}</h5>
        <div type="button" class="fs-modal__close" (click)="closeModal('languageDialog')"></div>
      </div>
      <div class="language-container">
        <div class="text-center light-gray-text margin-bottom-20">
          {{ 'footer.language-pop-up.caption' | translate }}
        </div>
        <span *ngFor="let language of languages">
          <a (click)='changeLanguage(language.code)'>
            <div class="language-item" role="button" class="light-gray-text text-center">
              {{ language.label }}
            </div>
          </a>
        </span>
      </div>
    </div>
  </div>
</modal>

